import { useState, useRef, useCallback, useEffect } from "react";

export function useAudio() {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const audioControllRef = useRef<HTMLAudioElement | null>(null);
  const [currentAudioSrc, setCurrentAudioSrc] = useState<string>("");

  const playSound = useCallback(
    (src: string , audioControllDom:HTMLAudioElement | null) => {
      // すでに同じ音声が再生中なら継続
      if (
        audioRef.current &&
        currentAudioSrc === src &&
        !audioRef.current.paused
      ) {
        return;
      }

      // 他の音声を止めて新しい音声を再生
      if (audioRef.current) {
        audioRef.current.pause();
        if (audioRef.current.parentElement) {
          audioRef.current.remove();
        }
      }

      const audio = new Audio(src);

      // 指定されたDOM配下に追加
      audioControllRef.current = audioControllDom;
      if (audioControllRef.current) {
        audio.controls = true;
        audioControllRef.current.appendChild(audio);
      }


      audioRef.current = audio;
      setCurrentAudioSrc(src);

      audio.play();

      audio.onended = () => {
        setCurrentAudioSrc("");
        audioRef.current = null;
        if (audio.parentElement) audio.remove();
      };
    },
    [currentAudioSrc]
  );

  const stopSound = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
      setCurrentAudioSrc("");

      audioRef.current = null;
      audioControllRemove();
    }
  }, []);

  const audioControllRemove = useCallback(() => {
    if (audioControllRef.current) {
      audioControllRef.current.querySelectorAll("audio").forEach((a) => a.remove());
    }
    audioControllRef.current = null;
  }, []);

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
        audioControllRemove();
      }
    };
  }, []);

  return { playSound, stopSound, currentAudioSrc };
}
